import React from 'react';
import { Button, ButtonProps } from '@mui/material';

import { AppColors } from '../utils/utils';
import styled from '@emotion/styled';

const StyledButton = styled(Button)<ButtonProps>((theme) => ({
  width: 'fit-content',
  height: 42,
  background: AppColors.blueGradient,
  borderRadius: '8px',
  border: 0,
  color: 'white',
  padding: '10px 32px',
  textTransform: 'none',
  fontSize: '1.2rem',
  fontWeight: 600,
  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
  transition: '0.3s',
  '&:hover': {
    boxShadow: '0 6px 15px rgba(0, 0, 0, 0.3)',
    background: AppColors.blueGradient,
  },
}));

export const BlueGradientButton: React.FC<ButtonProps> = (props) => {
  return <StyledButton {...props} />;
};
